module.exports = __webpack_public_path__ + "TB_Powerup_Melody_B.wav.50a82b86.mp3";


//////////////////
// WEBPACK FOOTER
// ./client/components/sounds/power_up/TB_Powerup_Melody_B.wav.mp3
// module id = 505
// module chunks = 0